import * as React from 'react';
import { FileVirusStatus } from '@citrite/sf-api';
import { t } from '../util';
export function hasVirus(item) {
  return item.VirusStatus === FileVirusStatus.VirusWarning;
}
export function isMarkedAsFalsePositive(item) {
  return item.VirusStatus === FileVirusStatus.MarkedAsFalsePostive;
}
export function getVirusDialogMessage(item, accountPrefs) {
  if (accountPrefs.EnableAntiVirus) {
    if (isMarkedAsFalsePositive(item)) {
      return t('citrix-files-ui:virus.file_marked_as_false_positive_warn');
    } else if (hasVirus(item)) {
      if (accountPrefs.VirusStrictness === 0) {
        if (accountPrefs.IsArchiveAccount) {
          return t('citrix-files-ui:virus.malicious_file_warn_archive');
        } else {
          return t('citrix-files-ui:virus.malicious_file_warn');
        }
      } else {
        if (accountPrefs.IsArchiveAccount) {
          return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("p", null, t('citrix-files-ui:virus.malicious_file_block_archive')), /*#__PURE__*/React.createElement("p", null, t('citrix-files-ui:virus.contact_admin')));
        } else {
          return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("p", null, t('citrix-files-ui:virus.malicious_file_block')), /*#__PURE__*/React.createElement("p", null, t('citrix-files-ui:virus.contact_admin')));
        }
      }
    } else if (blockAsUnscanned(item, accountPrefs)) {
      return t('citrix-files-ui:virus.unscanned_file_block');
    }
  }
  return t('citrix-files-ui:virus.malicious_file');
}
export function getVirusDialogActionMessage(item, accountPrefs) {
  if (accountPrefs.EnableAntiVirus) {
    if (hasVirus(item)) {
      if (accountPrefs.VirusStrictness === 0) {
        return t('citrix-files-ui:virus.malicious_file_warn_action');
      } else {
        return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("p", null, t('citrix-files-ui:virus.malicious_file_block_action')), /*#__PURE__*/React.createElement("p", null, t('citrix-files-ui:virus.contact_admin')));
      }
    } else if (blockAsUnscannedAction(item, accountPrefs)) {
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("p", null, t('citrix-files-ui:virus.unscanned_file_block_action')), /*#__PURE__*/React.createElement("p", null, t('citrix-files-ui:virus.contact_admin')));
    }
  }
  return t('citrix-files-ui:virus.malicious_file');
}
export function getVirusDialogTitle(item, accountPrefs) {
  if (accountPrefs.EnableAntiVirus) {
    if (isMarkedAsFalsePositive(item)) {
      return t('citrix-files-ui:virus.file_marked_as_false_positive_title');
    } else if (hasVirus(item)) {
      return t('citrix-files-ui:virus.malicious_file_title');
    } else if (blockAsUnscanned(item, accountPrefs)) {
      return t('citrix-files-ui:virus.unscanned_file_block_title');
    }
  }
  return t('citrix-files-ui:caution');
}
export function shouldWarnForVirus(item, accountPrefs) {
  return accountPrefs.EnableAntiVirus && (hasVirus(item) || isMarkedAsFalsePositive(item)) || blockAsUnscanned(item, accountPrefs);
}
export function blockAsUnscanned(item, accountPrefs) {
  return item.VirusStatus === FileVirusStatus.NotScanned && accountPrefs.VirusStrictness > 1;
}
export function blockAsUnscannedAction(item, accountPrefs) {
  return item.VirusStatus === FileVirusStatus.NotScanned && accountPrefs.VirusStrictness === 2;
}
export function virusBlocksActions(item, accountPrefs) {
  return hasVirus(item) && accountPrefs.VirusStrictness > 0;
}